import Tracking from './Tracking';

function Home() {
  return (
    <Tracking />
  );
}

export default Home;
